
import { IMyHomepageDetail } from '@/types';
import { Vue, Component, Prop } from 'vue-property-decorator';
import InterestSetting from '@/components/homepage/interest-setting.vue';

@Component({
  name: 'HomepageInterestSetting',
  components: {
    InterestSetting,
  },
})
export default class extends Vue {
  @Prop({ required: true }) private detail!: IMyHomepageDetail
}
